// Dashboard Colour maps

import { OrganizationStatus } from "@/modules/organizations/enums/organization-status"
import { PlanType } from "@/modules/organizations/types/plan-type"

export const STAGE_COLOURS: Record<string, string> = {
    Applied: "#6366f1",
    Screened: "#8b5cf6",
    Candidate: "#3b82f6",
    Hired: "#10b981",
    Rejected: "#ef4444",
}

export const EMPLOYEE_STATUS_COLOURS: Record<string, string> = {
    Pending: "#f59e0b",
    Active: "#10b981",
}

export const STATUS_STYLES: Record<string, string> = {
    [OrganizationStatus.Active]: "bg-green-100 text-green-700 dark:bg-green-500/20 dark:text-green-400",
    [OrganizationStatus.Pending]: "bg-orange-100 text-orange-700 dark:bg-orange-500/20 dark:text-orange-400",
    [OrganizationStatus.Inactive]: "bg-red-100 text-red-700 dark:bg-red-500/20 dark:text-red-400",
}

export const PLAN_STYLES: Record<string, string> = {
    [PlanType.Recruitment]: "bg-indigo-100 text-indigo-700 dark:bg-indigo-500/20 dark:text-indigo-400",
    [PlanType.Onboarding]: "bg-cyan-100 text-cyan-700 dark:bg-cyan-500/20 dark:text-cyan-400",
    [PlanType.FullHiring]: "bg-violet-100 text-violet-700 dark:bg-violet-500/20 dark:text-violet-400",
}
